import { AnyAction } from 'redux';
import * as retireActions from 'stash/actions/retire';

type RetireState = Record<string, unknown>;

const retireReducer = (
	state: RetireState = {},
	action: AnyAction
): RetireState => {
	switch (action.type) {
		case retireActions.SET_RETIRE_STATE:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default retireReducer;
